var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-7 pt-3",staticStyle:{"height":"100%","overflow-y":"scoll"}},[_c('router-view')],1),_c('page-loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }